import { useRouter } from "@/utils/router";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import { clsx } from "clsx";
import { getFile } from "@/entities/DataAssociation/DataAssociation.queries";

export function SourceFile({
    fileId,
    onSelect,
}: {
    fileId: string;
    onSelect: () => void;
}) {
    const router = useRouter();
    const { data: file, isLoading } = useApiQuery(getFile, {
        params: { fileId },
    });

    if (!file && isLoading)
        return (
            <div
                className={clsx(
                    "bg-selected h-6 w-full",
                    "animate-pulse rounded",
                )}
            />
        );

    if (!file) return null;

    return (
        <li
            onClick={() => {
                onSelect();
                setTimeout(() => {
                    router.navigate(
                        `/beta/companies/${router.params.companyId}/labeling/files/${file.id}`,
                    );
                }, 0);
            }}
        >
            <div
                className={clsx(
                    "flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1",
                    "hover:bg-hover",
                )}
            >
                <strong
                    className={clsx("body-s cursor-pointer", "font-semibold")}
                >
                    Labeled File
                </strong>
                <p className={clsx("body-s cursor-pointer text-slate-500")}>
                    {file.id.slice(-6)}
                </p>
            </div>
        </li>
    );
}
